import { render, staticRenderFns } from "./CourseSalseRankCard.vue?vue&type=template&id=3ac6961c&scoped=true"
import script from "./CourseSalseRankCard.vue?vue&type=script&lang=js"
export * from "./CourseSalseRankCard.vue?vue&type=script&lang=js"
import style0 from "./CourseSalseRankCard.vue?vue&type=style&index=0&id=3ac6961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac6961c",
  null
  
)

export default component.exports